/**
 * Whether the caller's plant has inspection (EXV-042/045): the server's `has_inspection` from `GET board/batches/`,
 * shared by the menu and the picker, single-flighted. The client decides nothing — no batch number lives here.
 */
import { useEffect, useSyncExternalStore } from 'react';
import { fetchBoardBatches } from './api';

const listeners = new Set();
let snapshot = { loaded: false, hasInspection: false, batches: [], page: 1, pageSize: null, total: 0, options: null, settings: null, error: null };
let inflight = null;
const emit = () => listeners.forEach((l) => l());

export function loadInspectionPresence({ force = false, page, filters = {} } = {}) {
  if (inflight && !force) return inflight;
  inflight = fetchBoardBatches(page || 1, filters)
    .then((body) => {
      const d = body?.data || {};
      snapshot = { loaded: true, hasInspection: !!d.has_inspection, batches: Array.isArray(d.batches) ? d.batches : [], page: d.page || 1,
        pageSize: d.page_size || null, total: d.total || 0, options: d.options || null, settings: d.settings || null, error: null };
    })
    .catch((err) => {
      snapshot = { loaded: true, hasInspection: false, batches: [], page: 1, pageSize: null, total: 0, options: null, settings: null, error: err };
    })
    .finally(emit);
  return inflight;
}

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const getSnapshot = () => snapshot;

export default function useInspectionPresence({ enabled = true } = {}) {
  const s = useSyncExternalStore(subscribe, getSnapshot);
  useEffect(() => { if (enabled && !s.loaded) loadInspectionPresence(); }, [enabled, s.loaded]);
  return enabled ? s : { ...s, hasInspection: false };
}
